import { render, staticRenderFns } from "./WidgetWorkorders.vue?vue&type=template&id=33ae2116&scoped=true&"
import script from "./WidgetWorkorders.vue?vue&type=script&lang=js&"
export * from "./WidgetWorkorders.vue?vue&type=script&lang=js&"
import style0 from "./WidgetWorkorders.vue?vue&type=style&index=0&id=33ae2116&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ae2116",
  null
  
)

export default component.exports